import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  ProductosCargaMasivaDispatcher,
  productosCargaMasivaDispatcher
} from "./productosCargaMasiva.dispatcher";
import {
  ProductosCargaMasivaStore,
  productosCargaMasivaStore
} from "./productosCargaMasiva.store";
import ProductosCargaMasivaComponent from "../../components/productosCargaMasiva";

interface Props
  extends ProductosCargaMasivaStore,
    ProductosCargaMasivaDispatcher {}

interface State {}

@ReduxConnect(productosCargaMasivaStore, productosCargaMasivaDispatcher)
export default class ProductosCargaMasivaContainer extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Productos Carga Masiva" />
          <ProductosCargaMasivaComponent
            validarProductosCargaMasiva={this.props.validarProductosCargaMasiva}
            procesarProductosCargaMasiva={
              this.props.procesarProductosCargaMasiva
            }
            searching={this.props.searching}
            saving={this.props.saving}
            validationResult={this.props.validationResult}
            processingResult={this.props.processingResult}
          />
        </Layout>
      </main>
    );
  }
}
